<template>
    <div class="card has-footer">
        <div
            v-for="stream in streamsInDisplayOrder"
            class="w-full lg:w-1/2 bg-neutral-lighter mb-lg"
        >
            <checkbox-input
                v-model="selectedStreams"
                :value="stream.name"
                class="items-center w-full p-xl"
                style="height: 117px;"
                :disabled="stream.owned_by_customer"
            >
                <div>
                    <span class="headline-md font-bold">
                        {{ stream.name }}
                    </span>
                    <span
                        v-if="streamIsIncluded(stream)"
                        class="line-through block text-sm mt-xs"
                    >
                        {{ format_sek_per_month(stream.monthly_price) }}
                    </span>

                    <span
                        v-if="streamIsIncluded(stream)"
                        class="block text-sm mt-xs"
                    >
                        {{ format_sek_per_month(0) }}
                    </span>

                    <span
                        v-else
                        class="block text-sm"
                    >
                        {{ format_sek_per_month(stream.monthly_price) }}
                    </span>
                </div>
            </checkbox-input>
        </div>

        <div class="justify-between flex flex-col flex-col-reverse md:flex-row items-center py-lg px-xl md:px-3xl bg-neutral-darker rounded-b-lg -mx-lg md:-mx-2xl -mb-xl mt-xl">
            <span class="text-white font-semibold">
                Månadskostnad: {{ format_sek_per_month(streamMonthlyCost) }}
            </span>

            <upgrade-streams-button :selected-stream-articles="selectedStreamArticles" />
        </div>
    </div>
</template>
<script>
    import StreamMixin from '../../Shared/StreamMixin';
    import UpgradeStreamsButton from './UpgradeStreamsButton';

    export default {
        components: { UpgradeStreamsButton },
        mixins: [StreamMixin],
        props: {
            streams: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                selectedStreams: [],
            };
        },
        computed: {
            selectedStreamArticles() {
                return this.selectedStreams.map((selectedStream) => {
                    return this.streams.find((streamObject) => streamObject.name === selectedStream);
                });
            },
            streamsInDisplayOrder() {
                const streams = this.streams;

                return streams.sort((a, b) => {
                    if (a.owned_by_customer && b.owned_by_customer) {
                        return 0;
                    }

                    if (b.owned_by_customer) {
                        return 1;
                    }

                    return -1;
                });
            },
        },
        created() {
            // Checks the checkbox for streams the customer already have
            this.streams
                .filter((stream) => stream.owned_by_customer)
                .forEach((stream) => this.selectedStreams.push(stream.name));
        },
    };
</script>
